import {connect} from 'react-redux';
import {MoveMenu as Component} from './MoveMenu';
import {
  setRotorAdaptersControlVisibility,
  setRotorAdaptersHeld,
  setHeldObject,
  setHeld,
  setMoveMenu,
  showMoveMenu
} from '@learningblocks/protocol-redux/lib/Actions';

function mapStateToProps(state, ownProps) {
  return {
    type: ownProps.type,
    connect: ownProps.connect,

    targetList: state.notebook.protocolSection.scene.targetList,
    display: state.notebook.protocolSection.scene.moveMenu.display,
    // display: state.moveMenu.display,
    sceneScale: state.notebook.protocolSection.scene.sceneScale,
    userScale: state.notebook.protocolSection.scene.userScale,
  }
}

function mapDispatchToProps(dispatch) {
  return {
    setHeld: (data) => {
      dispatch(setHeld(data))
    },
    setHeldObject: (data) => {
      dispatch(setHeldObject(data))
    },
    setRotorAdaptersControlVisibility: (data) => {
      dispatch(setRotorAdaptersControlVisibility(data))
    },
    showMoveMenu: (data) => {
      dispatch(showMoveMenu(data))
    },
    setMoveMenu: (data) => {
      dispatch(setMoveMenu(data))
    },
    setRotorAdaptersHeld: (data) => {
      dispatch(setRotorAdaptersHeld(data))
    },
  };
}

export const MoveMenu = connect(
  mapStateToProps,
  mapDispatchToProps
)(Component);
